module.exports = __webpack_public_path__ + "static/media/YF75_06.ec9196d7.jpg";